<template>
  <div class="wages wrapper shadow">
    <div class="operation">
      <div class="left"><div class="main-title">部门年度工资汇总表</div></div>
      <div class="right">
        <el-date-picker
          class="department"
          v-model="query.year"
          type="year"
          placeholder="请选择年度"
          format="YYYY"
          value-format="YYYY"
        />
        <el-select
          class="department"
          v-model="query.departmentId"
          placeholder="请选择部门"
        >
          <el-option
            v-for="item in departmentOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button type="primary" @click="getList">查询</el-button>
        <el-button type="primary" @click="exportSubmitForm">导出</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      class="table"
      header-row-class-name="main-table-header"
      :data="tableData"
      border
      height="670"
      :span-method="objectSpanMethod"
    >
      <el-table-column
        label="部门"
        min-width="150"
        prop="department"
        align="center"
        fixed="left"
      >
      </el-table-column>
      <el-table-column label="姓名" prop="person" align="center" fixed="left">
      </el-table-column>
      <el-table-column label="岗位级别" prop="jobLevel" align="center" fixed="left">
      </el-table-column>
      <el-table-column label="一月" min-width="110" align="center">
        <el-table-column
          prop="m1p1"
          label="基本工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m1p2"
          label="工龄工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m1p3"
          label="绩效工资"
          min-width="85"
          align="center"
        />
        <el-table-column
            prop="m1p4"
            label="油餐补"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m1p5"
            label="其他工资"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m1p6"
            label="社保扣款"
            min-width="85"
            align="center"
        />

        <el-table-column
            prop="m1p7"
            label="其他扣款"
            min-width="85"
            align="center"
        />
      </el-table-column>
      <el-table-column label="二月" min-width="110" align="center">
        <el-table-column
          prop="m2p1"
          label="基本工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m2p2"
          label="工龄工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m2p3"
          label="绩效工资"
          min-width="85"
          align="center"
        />
        <el-table-column
            prop="m2p4"
            label="油餐补"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m2p5"
            label="其他工资"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m2p6"
            label="社保扣款"
            min-width="85"
            align="center"
        />

        <el-table-column
            prop="m2p7"
            label="其他扣款"
            min-width="85"
            align="center"
        />
      </el-table-column>
      <el-table-column label="三月" min-width="110" align="center">
        <el-table-column
          prop="m3p1"
          label="基本工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m3p2"
          label="工龄工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m3p3"
          label="绩效工资"
          min-width="85"
          align="center"
        />
        <el-table-column
            prop="m3p4"
            label="油餐补"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m3p5"
            label="其他工资"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m3p6"
            label="社保扣款"
            min-width="85"
            align="center"
        />

        <el-table-column
            prop="m3p7"
            label="其他扣款"
            min-width="85"
            align="center"
        />
      </el-table-column>
      <el-table-column label="四月" min-width="110" align="center">
        <el-table-column
          prop="m4p1"
          label="基本工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m4p2"
          label="工龄工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m4p3"
          label="绩效工资"
          min-width="85"
          align="center"
        />
        <el-table-column
            prop="m4p4"
            label="油餐补"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m4p5"
            label="其他工资"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m4p6"
            label="社保扣款"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m4p7"
            label="其他扣款"
            min-width="85"
            align="center"
        />
      </el-table-column>
      <el-table-column label="五月" min-width="110" align="center">
        <el-table-column
          prop="m5p1"
          label="基本工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m5p2"
          label="工龄工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m5p3"
          label="绩效工资"
          min-width="85"
          align="center"
        />
        <el-table-column
            prop="m5p4"
            label="油餐补"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m5p5"
            label="其他工资"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m5p6"
            label="社保扣款"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m5p7"
            label="其他扣款"
            min-width="85"
            align="center"
        />
      </el-table-column>
      <el-table-column label="六月" min-width="110" align="center">
        <el-table-column
          prop="m6p1"
          label="基本工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m6p2"
          label="工龄工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m6p3"
          label="绩效工资"
          min-width="85"
          align="center"
        />
        <el-table-column
            prop="m6p4"
            label="油餐补"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m6p5"
            label="其他工资"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m6p6"
            label="社保扣款"
            min-width="85"
            align="center"
        />

        <el-table-column
            prop="m6p7"
            label="其他扣款"
            min-width="85"
            align="center"
        />
      </el-table-column>
      <el-table-column label="七月" min-width="110" align="center">
        <el-table-column
          prop="m7p1"
          label="基本工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m7p2"
          label="工龄工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m7p3"
          label="绩效工资"
          min-width="85"
          align="center"
        />
        <el-table-column
            prop="m7p4"
            label="油餐补"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m7p5"
            label="其他工资"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m7p6"
            label="社保扣款"
            min-width="85"
            align="center"
        />

        <el-table-column
            prop="m7p7"
            label="其他扣款"
            min-width="85"
            align="center"
        />
      </el-table-column>
      <el-table-column label="八月" min-width="110" align="center">
        <el-table-column
          prop="m8p1"
          label="基本工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m8p2"
          label="工龄工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m8p3"
          label="绩效工资"
          min-width="85"
          align="center"
        />
        <el-table-column
            prop="m8p4"
            label="油餐补"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m8p5"
            label="其他工资"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m8p6"
            label="社保扣款"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m8p7"
            label="其他扣款"
            min-width="85"
            align="center"
        />
      </el-table-column>
      <el-table-column label="九月" min-width="110" align="center">
        <el-table-column
          prop="m9p1"
          label="基本工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m9p2"
          label="工龄工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m9p3"
          label="绩效工资"
          min-width="85"
          align="center"
        />
        <el-table-column
            prop="m9p4"
            label="油餐补"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m9p5"
            label="其他工资"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m9p6"
            label="社保扣款"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m9p7"
            label="其他扣款"
            min-width="85"
            align="center"
        />
      </el-table-column>
      <el-table-column label="十月" min-width="110" align="center">
        <el-table-column
          prop="m10p1"
          label="基本工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m10p2"
          label="工龄工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m10p3"
          label="绩效工资"
          min-width="85"
          align="center"
        />
        <el-table-column
            prop="m10p4"
            label="油餐补"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m10p5"
            label="其他工资"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m10p6"
            label="社保扣款"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m10p7"
            label="其他扣款"
            min-width="85"
            align="center"
        />
      </el-table-column>
      <el-table-column label="十一月" min-width="110" align="center">
        <el-table-column
          prop="m11p1"
          label="基本工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m11p2"
          label="工龄工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m11p3"
          label="绩效工资"
          min-width="85"
          align="center"
        />
        <el-table-column
            prop="m11p4"
            label="油餐补"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m11p5"
            label="其他工资"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m11p6"
            label="社保扣款"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m11p7"
            label="其他扣款"
            min-width="85"
            align="center"
        />
      </el-table-column>
      <el-table-column label="十二月" min-width="110" align="center">
        <el-table-column
          prop="m12p1"
          label="基本工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m12p2"
          label="工龄工资"
          min-width="85"
          align="center"
        />
        <el-table-column
          prop="m12p3"
          label="绩效工资"
          min-width="85"
          align="center"
        />
        <el-table-column
            prop="m12p4"
            label="油餐补"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m12p5"
            label="其他工资"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m12p6"
            label="社保扣款"
            min-width="85"
            align="center"
        />
        <el-table-column
            prop="m12p7"
            label="其他扣款"
            min-width="85"
            align="center"
        />
      </el-table-column>
    </el-table>
  </div>
</template>
<script setup>
import { ref } from "@vue/reactivity";
import { fetchLastMonth } from "@/api/payroll";
import { fetchDepartmentAnnual } from "@/api/report";
import { fetchList as fetchDepartmentList } from "@/api/department";
import { onMounted } from "vue";

onMounted(() => {
  getLastMonth();
  getDepartmentList();
});

const getLastMonth = () => {
  fetchLastMonth().then((res) => {
    query.value.year = res.data.split("-")[0];
  });
};

const getList = () => {
  if (!query.value.year) {
    ElMessage({
      type: "error",
      message: "请选择年度！",
    });
    return;
  }
  if (!query.value.departmentId) {
    ElMessage({
      type: "error",
      message: "请选择部门！",
    });
    return;
  }
  fetchDepartmentAnnual(query.value).then((res) => {
    let data = res.data;
    handleData(data);
  });
};

const handleData = (data) => {
  let personList = [];
  let list = [];
  let department = "";
  if (data.length > 0) {
    department = data[0].department;
  }
  data
    .map((e) => e.person)
    .forEach((d) => {
      if (personList.indexOf(d) === -1) {
        personList.push(d);
      }
    });
  personList.forEach((e) => {
    let item = {};
    item.department = department;
    item.person = e;
    item.jobLevel = data.find((d) => d.person === e).jobLevel;
    for (let i = 1; i <= 12; i++) {
      item["m" + i + "p1"] = data
        .filter((d) => d.person === e && d.month === i)
        .map((d) => d.baseSalary)
        .reduce((a, b) => a + b, 0);
    }
    for (let i = 1; i <= 12; i++) {
      item["m" + i + "p2"] = data
        .filter((d) => d.person === e && d.month === i)
        .map((d) => d.annualLeaveAllowance)
        .reduce((a, b) => a + b, 0);
    }
    for (let i = 1; i <= 12; i++) {
      item["m" + i + "p3"] = data
        .filter((d) => d.person === e && d.month === i)
        .map((d) => d.performanceSalary)
        .reduce((a, b) => a + b, 0);
    }
    for (let i = 1; i <= 12; i++) {
      item["m" + i + "p4"] = data
          .filter((d) => d.person === e && d.month === i)
          .map((d) => d.subsidy)
          .reduce((a, b) => a + b, 0);
    }
    for (let i = 1; i <= 12; i++) {
      item["m" + i + "p5"] = data
          .filter((d) => d.person === e && d.month === i)
          .map((d) => d.otherSalary)
          .reduce((a, b) => a + b, 0);
    }
    for (let i = 1; i <= 12; i++) {
      item["m" + i + "p6"] = data
          .filter((d) => d.person === e && d.month === i)
          .map((d) => d.socialSecurity)
          .reduce((a, b) => a + b, 0);
    }
    for (let i = 1; i <= 12; i++) {
      item["m" + i + "p7"] = data
          .filter((d) => d.person === e && d.month === i)
          .map((d) => d.deductions)
          .reduce((a, b) => a + b, 0);
    }
    list.push(item);
  });
  let count = {};
  count.department = "合计";
  count.person = "合计";
  for (let i = 1; i <= 12; i++) {
    count["m" + i + "p1"] = data
      .filter((d) => d.month === i)
      .map((d) => d.baseSalary)
      .reduce((a, b) => a + b, 0);
    count["m" + i + "p1"] = count["m" + i + "p1"].toFixed(2);
  }
  for (let i = 1; i <= 12; i++) {
    count["m" + i + "p2"] = data
      .filter((d) => d.month === i)
      .map((d) => d.annualLeaveAllowance)
      .reduce((a, b) => a + b, 0);
    count["m" + i + "p2"] = count["m" + i + "p2"].toFixed(2);
  }
  for (let i = 1; i <= 12; i++) {
    count["m" + i + "p3"] = data
      .filter((d) => d.month === i)
      .map((d) => d.performanceSalary)
      .reduce((a, b) => a + b, 0);
    count["m" + i + "p3"] = count["m" + i + "p3"].toFixed(2);
  }
  for (let i = 1; i <= 12; i++) {
    count["m" + i + "p4"] = data
        .filter((d) => d.month === i)
        .map((d) => d.subsidy)
        .reduce((a, b) => a + b, 0);
    count["m" + i + "p4"] = count["m" + i + "p4"].toFixed(2);
  }
  for (let i = 1; i <= 12; i++) {
    count["m" + i + "p5"] = data
        .filter((d) => d.month === i)
        .map((d) => d.otherSalary)
        .reduce((a, b) => a + b, 0);
    count["m" + i + "p5"] = count["m" + i + "p5"].toFixed(2);
  }
  for (let i = 1; i <= 12; i++) {
    count["m" + i + "p6"] = data
        .filter((d) => d.month === i)
        .map((d) => d.socialSecurity)
        .reduce((a, b) => a + b, 0);
    count["m" + i + "p6"] = count["m" + i + "p6"].toFixed(2);
  }
  for (let i = 1; i <= 12; i++) {
    count["m" + i + "p7"] = data
        .filter((d) => d.month === i)
        .map((d) => d.deductions)
        .reduce((a, b) => a + b, 0);
    count["m" + i + "p7"] = count["m" + i + "p7"].toFixed(2);
  }
  list.push(count);
  tableData.value = list;
};

//月份
const query = ref({
  year: "",
  departmentId: "",
});
import FileSaver from "file-saver";
import XLSX from "xlsx";
import { ElMessage } from "element-plus";

const exportSubmitForm = async () => {
  if (tableData.value.length === 0) {
    ElMessage({
      type: "error",
      message: "请先查询数据！",
    });
    return;
  }
  var wb = XLSX.utils.table_to_book(document.querySelector(".table"));
  var wbout = XLSX.write(wb, {
    bookType: "xlsx",
    bookSST: true,
    type: "array",
  });
  try {
    FileSaver.saveAs(
      new Blob([wbout], { type: "application/octet-stream" }),
      "部门年度工资汇总表-" +
        departmentOptions.value.find((e) => e.value == query.value.departmentId)
          .label +
        ".xlsx"
    );
  } catch (e) {
    if (typeof console !== "undefined") console.log(e, wbout);
  }
  return wbout;
};

// 选择部门
const departmentOptions = ref([]);

const getDepartmentList = () => {
  fetchDepartmentList().then((res) => {
    let list = res.data.list;
    departmentOptions.value = [];
    list.forEach((item) => {
      departmentOptions.value.push({
        value: item.id,
        label: item.name,
      });
    });
  });
};

// 表格
const tableData = ref([]);

const objectSpanMethod = ({ rowIndex, columnIndex }) => {
  if (rowIndex === tableData.value.length - 1) {
    if (columnIndex === 0) {
      return [1, 2];
    } else if (columnIndex === 1) {
      return [0, 0];
    }
  }
};
</script>
<style lang="scss" scoped>
.tips {
  line-height: 26px;
}
</style>
